var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_remove_24px","d":"M19,13H5V11H19Z","transform":"translate(-5 -11)","fill":"#66a9f4"}));
}

Remove.defaultProps = {"width":"14","height":"2","viewBox":"0 0 14 2"};

module.exports = Remove;

Remove.default = Remove;
